import { createSelector } from 'reselect';

export const getAllFundraiserAssignmentTypes = state => state.fundraiserAssignmentTypes;
export const getAllFundraiserAssignmentTypeLabels = createSelector(
	getAllFundraiserAssignmentTypes,
	types => types.map(type => type.type),
);

export const getPrimaryFundraiserAssignmentType = createSelector(
	getAllFundraiserAssignmentTypes,
	types => types.find(type => type.primary),
);

export const hasFundraiserAssignmentTypes = createSelector(
	getAllFundraiserAssignmentTypes,
	types => types && types.length > 1,
);



// WEBPACK FOOTER //
// ./src/redux/fundraiserAssignmentTypes/fundraiserAssignmentType.selector.js